import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useCampaignConfigSummary } from "../../hooks/useCampaignConfigSummary";

type CampaignType = "" | "MIGRATION" | "FIDELIZATION";

interface ConfigSummaryCardProps {
  campaignType: CampaignType;
}

export const ConfigSummaryCard = ({ campaignType }: ConfigSummaryCardProps) => {
  const { data, loading } = useCampaignConfigSummary(campaignType);

  const translateUnit = (unit?: string) => {
    if (unit === "YEARS") return "Años";
    if (unit === "MONTHS") return "Meses";
    return unit || "";
  };

  if (!campaignType) return null;

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, minHeight: 220 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={700} mb={2}>
          Parametrización configurada
        </Typography>

        {loading ? (
          <Typography>Cargando...</Typography>
        ) : !data ? (
          <Typography color="text.secondary">
            No hay parametrización configurada para este módulo.
          </Typography>
        ) : campaignType === "MIGRATION" ? (
          <Stack spacing={1}>
            <Typography variant="body1">{(data as any)?.message}</Typography>
            <Typography variant="body2" color="text.secondary">
              Unidad: {translateUnit((data as any)?.usefulLifeUnit)}
            </Typography>
          </Stack>
        ) : (
          <Stack spacing={1}>
            <Typography variant="body1">{(data as any)?.message}</Typography>            
            <Typography variant="body2" color="text.secondary">
              Unidad: {translateUnit((data as any)?.permanenceUnit)}
            </Typography>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};